// Keeps a partially typed year (e.g. "20") from committing as year 20
export const MIN_FIELD_DATE = new Date(1900, 0, 1);

export const FIELD_WIDTH = 132;
